import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { logout, onForbidden } from '../account/login';
import { fetchSubmitForm, fetchSubmitFormFailed, resetSubmitFormData } from '../common/submitForm';
import { hideModal } from '../common/activeModal';
import _ from 'lodash';

//- Actions
export const fetchGetGlobalCertificatesFailed = createAction('FETCH_GET_GLOBAL_CERTIFICATES_FAILED');
export const fetchGetGlobalCertificatesSuccess = createAction('FETCH_GET_GLOBAL_CERTIFICATES_SUCCESS');
export const fetchGetGlobalCertificates = createAction(
    'FETCH_GET_GLOBAL_CERTIFICATES',
    () => Api.getGlobalCertificates(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetGlobalCertificatesSuccess,
        onFail: fetchGetGlobalCertificatesFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchAddGlobalCertificate = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onAddGlobalCertificate(data));
};
export const onAddGlobalCertificate = createAction(
    'FETCH_ADD_GLOBAL_CERTIFICATE',
    (data) => Api.addGlobalCertificate(data),
    () => ({
        apiCall: true,
        onSuccess: onAddGlobalCertificateSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onAddGlobalCertificateSuccess = () => dispatch => {
    dispatch(fetchGetGlobalCertificates());
    dispatch(hideModal());
    dispatch(resetSubmitFormData());
};

export const fetchRemoveGlobalCertificate = (certId) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveGlobalCertificate(certId));
};
export const onRemoveGlobalCertificate = createAction(
    'FETCH_REMOVE_GLOBAL_CERTIFICATE',
    (certId) => Api.removeGlobalCertificate(certId),
    () => ({
        apiCall: true,
        onSuccess: onRemoveGlobalCertificateSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onRemoveGlobalCertificateSuccess = () => dispatch => {
    dispatch(fetchGetGlobalCertificates());
    dispatch(resetSubmitFormData());
};

export const fetchGetOrgCertificatesFailed = createAction('FETCH_GET_ORG_CERTIFICATES_FAILED');
export const fetchGetOrgCertificatesSuccess = createAction('FETCH_GET_ORG_CERTIFICATES_SUCCESS');
export const fetchGetOrgCertificates = createAction(
    'FETCH_GET_ORG_CERTIFICATES',
    (orgId) => Api.getOrgCertificates(orgId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrgCertificatesSuccess,
        onFail: fetchGetOrgCertificatesFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchAddOrgCertificate = (orgId, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onAddOrgCertificate(orgId, data));
};
export const onAddOrgCertificate = createAction(
    'FETCH_ADD_ORG_CERTIFICATE',
    (orgId, data) => Api.addOrgCertificate(orgId, data),
    (orgId, data) => ({
        apiCall: true,
        onSuccess: onAddOrgCertificateSuccess(orgId),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onAddOrgCertificateSuccess = (orgId) => () => dispatch => {
    dispatch(fetchGetOrgCertificates(orgId));
    dispatch(hideModal());
    dispatch(resetSubmitFormData());
};

export const fetchRemoveOrgCertificate = (orgId, certId) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveOrgCertificate(orgId, certId));
};
export const onRemoveOrgCertificate = createAction(
    'FETCH_REMOVE_ORG_CERTIFICATE',
    (orgId, certId) => Api.removeOrgCertificate(orgId, certId),
    (orgId, certId) => ({
        apiCall: true,
        onSuccess: onRemoveOrgCertificateSuccess(orgId),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onRemoveOrgCertificateSuccess = (orgId) => () => dispatch => {
    dispatch(fetchGetOrgCertificates(orgId));
    dispatch(resetSubmitFormData());
};

//- State
const initialState = {
    orgCertificates: null,
    globalCertificates: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_GET_GLOBAL_CERTIFICATES: (state) => {
        return { ...state, globalCertificates: null, error: null, fetching: true };
    },
    FETCH_GET_GLOBAL_CERTIFICATES_FAILED: (state, action) => {
        return { ...state, globalCertificates: null, error: action.payload, fetching: false };
    },
    FETCH_GET_GLOBAL_CERTIFICATES_SUCCESS: (state, action) => {
        return { ...state, globalCertificates: action.payload, error: null, fetching: false };
    },
    FETCH_GET_ORG_CERTIFICATES: (state) => {
        return { ...state, orgCertificates: null, error: null, fetching: true };
    },
    FETCH_GET_ORG_CERTIFICATES_FAILED: (state, action) => {
        return { ...state, orgCertificates: null, error: action.payload, fetching: false };
    },
    FETCH_GET_ORG_CERTIFICATES_SUCCESS: (state, action) => {
        return { ...state, orgCertificates: action.payload, error: null, fetching: false };
    }

}, initialState);

//- Selectors
export const getCertificate = state => state.orgCertificate;

export const loadingCertificate = state => getCertificate(state).fetching;

export const getOrgCertificates = state => getCertificate(state).orgCertificates;

export const getGlobalCertificates = state => getCertificate(state).globalCertificates;

export const getOrgCertificateDataById = (state, certId) => {
    let data = getOrgCertificates(state);

    if (_.isNil(data)) {
        return null;
    }

    return _.find(data, (elem) => elem.id === certId);
}

export const getGlobalCertificateDataById = (state, certId) => {
    let data = getGlobalCertificates(state);

    if (_.isNil(data)) {
        return null;
    }

    return _.find(data, (elem) => elem.id === certId);
}


// WEBPACK FOOTER //
// ./src/reducers/organization/orgCertificate.js